// src/pages/CostAnalysisPage.jsx
// Cost Analysis (3.49.0, Super Admins only): its own page in the left
// strip's Super Admin group, out of the Console:
//   /portal/cost-analysis/telnyx        Telnyx costs
//   /portal/cost-analysis/google-cloud  Google Cloud costs
//   /portal/cost-analysis/amazon-ses    Amazon SES (3.59.3): the AWS bill and our estimate
//   /portal/cost-analysis/whatsapp      WhatsApp (3.62.9): Meta's charges for the alerts
// The old Console addresses (/console/costs-telnyx, /console/costs-gcp; the
// low-balance emails link there) still open it. The Overview's pop-up stays.
import SectionTabs from '../components/SectionTabs';
import { TelnyxCosts, GcpCosts, AwsCosts, WhatsAppCosts } from './CostAnalysis';

const SECTIONS = [
  { id: 'telnyx',       label: 'Telnyx',       icon: '📡' },
  { id: 'google-cloud', label: 'Google Cloud', icon: '☁️' },
  { id: 'amazon-ses',   label: 'Amazon SES',   icon: '📧' },   // 3.59.3
  { id: 'whatsapp',     label: 'WhatsApp',     icon: '💬' },   // 3.62.9
];
const ALIASES = { 'costs-telnyx': 'telnyx', 'costs-gcp': 'google-cloud' };

export default function CostAnalysisPage() {
  return (
    <SectionTabs tabId="costs" title="💰 Cost Analysis" sections={SECTIONS} aliases={ALIASES}
      about="What Telnyx, Google Cloud, Amazon SES and WhatsApp cost each month, split into fax, voice and the rest, with a forecast for this month.">
      {sub => (
        <>
          {sub === 'telnyx' && <TelnyxCosts />}
          {sub === 'google-cloud' && <GcpCosts />}
          {sub === 'amazon-ses' && <AwsCosts />}
          {sub === 'whatsapp' && <WhatsAppCosts />}
        </>
      )}
    </SectionTabs>
  );
}
